module.exports = __webpack_public_path__ + "static/media/none-default.7d1202aa.png";